export default __webpack_public_path__ + "static/output-1-f3906f68bb5356f97271d5ba9b60359d.jpg";